import {createStore, combineReducers, applyMiddleware} from "redux";
import createSagaMiddleware from "redux-saga";
const sagaMiddleware = createSagaMiddleware();

export function createReduxStore(reducerName, reducer, saga) {
  const reducers = combineReducers({
    [reducerName]: reducer
  });
  const middleware = applyMiddleware(sagaMiddleware);
  let store = createStore(reducers, middleware);
  sagaMiddleware.run(saga);

  return store;
}
